var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "md-card",
        { staticClass: "review-issues-container" },
        [
          _c(
            "md-card-header",
            { staticClass: "md-card-header-icon md-card-header-warning" },
            [
              _c(
                "div",
                { staticClass: "card-icon icon-style" },
                [
                  _c("md-icon", [_vm._v("warning")]),
                  _vm._v("\n                Issues\n            "),
                ],
                1
              ),
              _c("create-issue", {
                staticClass: "create-issue-container",
                attrs: {
                  "related-entity-type": _vm.entityType,
                  "related-entity-ref": _vm.entityRef,
                  "open-dialog": _vm.isReview,
                },
                on: { issueCreated: _vm.addLogToInvoicePage },
              }),
            ],
            1
          ),
          _vm.issues && _vm.issues.length > 0
            ? _c(
                "div",
                { staticClass: "log-container" },
                _vm._l(_vm.issues, function (issue, index) {
                  return _c(
                    "md-card-content",
                    { key: index, staticClass: "issue-container" },
                    [
                      _c(
                        "md-card",
                        [
                          _c(
                            "md-card-content",
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "Issues Overview",
                                      query: { ref: "" + issue.issueReference },
                                    },
                                    target: "_blank",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(issue.issueReference) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                              _c("div", { staticClass: "details-box" }, [
                                _c("label", [_vm._v("Title")]),
                                _c("span", [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(issue.title) +
                                      "\n                            "
                                  ),
                                ]),
                              ]),
                              _c("div", { staticClass: "details-box" }, [
                                _c("label", [_vm._v("Status")]),
                                _c("span", [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(issue.statusName) +
                                      "\n                            "
                                  ),
                                ]),
                              ]),
                              _c("div", { staticClass: "details-box" }, [
                                _c("label", [_vm._v("Created by")]),
                                _c("span", [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(issue.createdByName) +
                                      "\n                            "
                                  ),
                                ]),
                              ]),
                              _c("div", { staticClass: "details-box" }, [
                                _c("label", [_vm._v("Created")]),
                                _c("span", [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm._f("dateFormat")(
                                          issue.createdDate,
                                          _vm.DATE_TYPES.standardDate
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              )
            : _c("div", { staticClass: "no-issues-container" }, [
                _vm._v("\n            No issues exist.\n        "),
              ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }